import React, { useState } from "react";
import "./settingsSidebar.css";
import OfficialCalendar from "./officialComponents/officialTable";
import OfficialForm from "./officialComponents/officialRegister";
import OfficalInfoTable from "./officialComponents/officialInfoTable";

const OfficialSideBar = () => {
  const [selectedPage, setSelectedPage] = useState("officialcal");

  const renderContent = () => {
    switch (selectedPage) {
      case "officialcal":
        return <OfficialCalendar/>;
      case "officialreg":
        return <OfficialForm/>
      case "OfficalInfoTable":
        return <OfficalInfoTable/>  
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <div className="sidebarContainer">
        <ul className="submenuClient">
          <li onClick={() => setSelectedPage("officialcal")}>Official Open Calendar</li>
          <li onClick={() => setSelectedPage("officialreg")}>Official Register</li>
          <li onClick={() => setSelectedPage("OfficalInfoTable")}>Official Table</li>

        </ul>
      </div>

      {/* Main Content */}
      <div className="contentContainer">{renderContent()}</div>
    </div>
  );
};

export default OfficialSideBar;
